import _taggedTemplateLiteral from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  grid-row: ", ";\n  justify-content: space-between;\n\n  ", "\n  ", "\n\n  color: var(", ");\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n      @supports (width: min(1px, 2px)) and (width: max(1px, 2px)) {\n        --output-position: max(\n          0px,\n          min(\n            calc(var(--position0) - (var(--output-size) / 2)),\n            calc(100% - var(--output-size))\n          )\n        );\n\n        justify-self: start;\n        margin-inline-start: var(--output-position);\n      }\n    "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  grid-row: ", ";\n  justify-self: center;\n\n  font-variant-numeric: tabular-nums;\n\n  color: var(\n    ", "\n  );\n\n  ", ":focus ~ & {\n    color: var(\n      ", "\n    );\n  }\n\n  ", ":hover ~ & {\n    color: var(\n      ", "\n    );\n  }\n\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n      &::after {\n        content: '';\n        z-index: 0;\n        position: absolute;\n        inset: -8px var(--thumb-radius);\n\n        /* Using N gradients with one step here instead of one gradient with N steps due to a rendering bug in Chrome */\n        background-image: ", ";\n        background-position-x: ", ";\n        background-repeat: no-repeat;\n        background-size: 1px 100%;\n      }\n    "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n            background-color: var(--slider-track-color);\n          "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n            background: linear-gradient(\n              var(--gradient-direction),\n              var(--slider-track-color) var(--start),\n              var(--slider-track-fill-color) var(--start),\n              var(--slider-track-fill-color) var(--end),\n              var(--slider-track-color) var(--end)\n            );\n          "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n            background: linear-gradient(\n              var(--gradient-direction),\n              var(--slider-track-fill-color) var(--position0),\n              var(--slider-track-color) var(--position0)\n            );\n          "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n        opacity: 0.5;\n      "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  --gradient-direction: to right;\n\n  [dir='rtl'] & {\n    --gradient-direction: to left;\n  }\n\n  position: relative;\n  grid-row: ", ";\n  grid-column: 1;\n\n  height: var(--track-size);\n\n  &::before {\n    content: '';\n    z-index: 1;\n    position: absolute;\n    inset: 0;\n\n    ", "\n\n    ", "\n  }\n\n  ", "\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  z-index: 1;\n\n  grid-row: ", ";\n  grid-column: 1;\n  width: 100%;\n  height: var(--thumb-diameter);\n  margin: 0;\n  padding: 0;\n\n  background: transparent;\n  outline-offset: var(", ");\n  /* Prevent fade on iOS when disabled*/\n  opacity: 1;\n\n  appearance: none;\n\n  pointer-events: none;\n\n  &::-webkit-slider-thumb {\n    ", "\n  }\n\n  &:focus::-webkit-slider-thumb {\n    border-color: var(\n      ", "\n    );\n  }\n\n  &::-moz-range-thumb {\n    ", "\n  }\n\n  &:focus::-moz-range-thumb {\n    border-color: var(\n      ", "\n    );\n  }\n\n  &::-webkit-slider-track {\n    pointer-events: none;\n  }\n\n  &::-moz-range-track {\n    pointer-events: none;\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n      --ratio1: calc((var(--value1) - var(--min)) / var(--range));\n      --position1: calc(\n        var(--thumb-radius) + (var(--ratio1) * (100% - var(--thumb-diameter)))\n      );\n\n      --midpoint: calc((var(--position0) + var(--position1)) / 2);\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  --range: calc(var(--max) - var(--min));\n\n  --thumb-diameter: 26px;\n  --thumb-radius: calc(var(--thumb-diameter) / 2);\n\n  --output-size: 1ch;\n  --track-size: 2px;\n\n  --ratio0: calc((var(--value0) - var(--min)) / var(--range));\n  --position0: calc(\n    var(--thumb-radius) + (var(--ratio0) * (100% - var(--thumb-diameter)))\n  );\n\n  --slider-track-color: var(\n    ", "\n  );\n  --slider-track-fill-color: var(\n    ", "\n  );\n\n  ", "\n\n  display: grid;\n  grid-template-rows:\n    [ ", " ] auto\n    var(", ")\n    [ ", " ] auto\n    var(", ")\n    [ ", " ] auto;\n  align-items: center;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  padding: 0;\n\n  border: 0;\n\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n          cursor: grab;\n          &:active {\n            cursor: grabbing;\n          }\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n          cursor: not-allowed;\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: var(--thumb-diameter);\n  height: var(--thumb-diameter);\n\n  background-color: var(", ");\n  border-color: var(\n    ", "\n  );\n  border-style: solid;\n  border-width: 1px;\n  border-radius: 50%;\n  box-shadow: none;\n\n  appearance: none;\n  pointer-events: auto;\n\n  &:hover {\n    border-color: var(\n      ", "\n    );\n  }\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import curry from 'lodash/curry';
import { injectTypography } from '../../utils/injectTypography';
import { injectSpacing } from '../../api/spacing/injectSpacing';
import { injectOSXFontSmoothing } from '../../utils/injectOSXFontSmoothing';
var getStateColor = curry(function (statesFn, colorFn, props) {
  var color = colorFn(props);
  var states = statesFn(props);
  if (props.disabled) return states.disabled || color;
  if (props.invalid) return states.invalid || color;
  return color;
});
var getSliderTrackColor = getStateColor(function (props) {
  return {
    disabled: props.theme.colors.ui.divider
  };
});
var getSliderFillColor = getStateColor(function (props) {
  return {
    disabled: props.theme.colors.ui.highlight.secondary,
    invalid: props.theme.colors.ui.error
  };
});
var getSliderThumbColor = getStateColor(function (props) {
  return {
    disabled: props.theme.colors.interaction.secondary.disabled,
    invalid: props.theme.colors.ui.error
  };
});
var getOutputColor = getStateColor(function (props) {
  return {
    disabled: props.theme.colors.interaction.label.disabled,
    invalid: props.theme.colors.ui.error
  };
});
var injectThumb = css(_templateObject(), function (props) {
  return props.theme.colors.background.level[1];
}, getSliderThumbColor(function (props) {
  return props.theme.colors.interaction.secondary.default;
}), getSliderThumbColor(function (props) {
  return props.theme.colors.interaction.secondary.hover;
}), function (props) {
  return props.disabled ? css(_templateObject2()) : css(_templateObject3());
}); // When numberOfThumbs is 2 (dual slider) the container should be a `fieldset`,
// some styles here are a result of this.

export var StyledContainer = styled.div(_templateObject4(), injectSpacing('margin'));
export var StyledSliderContainer = styled.div(_templateObject5(), getSliderTrackColor(function (props) {
  return props.theme.colors.ui.divider;
}), getSliderFillColor(function (props) {
  return props.theme.colors.ui.highlight.secondary;
}), function (props) {
  return props.numberOfThumbs === 2 && css(_templateObject6());
}, "output"
/* GridRows.output */
, function (props) {
  return props.theme.responsive.spacing.xs;
}, "track"
/* GridRows.track */
, function (props) {
  return props.theme.responsive.spacing.xxs;
}, "bounds"
/* GridRows.bounds */
);
export var StyledSlider = styled.input.attrs({
  type: 'range'
})(_templateObject7(), "track"
/* GridRows.track */
, function (props) {
  return props.theme.responsive.spacing.xxs;
}, injectThumb, getOutputColor(function (props) {
  return props.theme.colors.interaction.secondary.focus;
}), injectThumb, getOutputColor(function (props) {
  return props.theme.colors.interaction.secondary.focus;
}));
export var StyledTrack = styled.div(_templateObject8(), "track"
/* GridRows.track */
, function (props) {
  return props.disabled && css(_templateObject9());
}, function (props) {
  switch (props.numberOfThumbs) {
    case 1:
      return css(_templateObject10());

    case 2:
      return css(_templateObject11());

    default:
      return css(_templateObject12());
  }
}, function (props) {
  return props.marks.length && css(_templateObject13(), props.marks.map(function () {
    return 'linear-gradient(to right, transparent, var(--slider-track-color) 0 1px)';
  }).join(', '), props.marks.map(function (value) {
    return "calc(".concat(value, " / var(--range) * 100%)");
  }).join(', '));
});
export var StyledOutput = styled.output(_templateObject14(), "output"
/* GridRows.output */
, getOutputColor(function (props) {
  return props.theme.colors.interaction.label.default;
}), StyledSlider, getOutputColor(function (props) {
  return props.theme.colors.interaction.label.focus;
}), StyledSlider, getOutputColor(function (props) {
  return props.theme.colors.interaction.label.hover;
}), function (props) {
  return injectTypography(props, 'copy1');
}, injectOSXFontSmoothing(true), function (props) {
  return props.numberOfThumbs === 1 && css(_templateObject15());
});
export var StyledMinMax = styled.div(_templateObject16(), "bounds"
/* GridRows.bounds */
, function (props) {
  return injectTypography(props, 'copy2');
}, injectOSXFontSmoothing(true), function (props) {
  return props.theme.colors.ui.tertiary;
});